import React, { useState } from 'react';
/* 🔴 EL MUÑECO LLEVA SUS ESTILOS CONSIGO. NO SE QUITA ESTA LINEA.
   Hasta hoy no importaba ningun CSS: sus clases --fv-dolor-*, fv-dosmunecos,
   crm-portal-body__zone, fv-btn...-- viven en `mis-pautas-paciente.css`, y
   funcionaba DE MILAGRO porque la pantalla de la PACIENTE ya cargaba ese
   fichero. Al montarlo en el informe del FISIO (que no lo carga) se abria SIN
   UN SOLO ESTILO: sin medidas, sin colores, sin zonas visibles. Se abria y no
   se veia nada -- ni error, ni aviso, ni hueco.
   Un componente que solo funciona si OTRO carga sus estilos no es reutilizable.
   Las reglas van con prefijo propio (fv-, crm-portal-, boton_): no pisan nada
   de la pantalla que lo hospede. */
import './mis-pautas-paciente.css';

/**
 * MapaDolor — §8.3 · «Me dolió» abre una pantalla propia (dato clínico).
 * Muñeco de 21 zonas (frente/espalda, mismas coords), intensidad por TOQUE
 * (1 molesta · 2 duele · 3 duele mucho · 4 borra), 5 motivos clínicos y la
 * escala EVA de este momento. No se copia el código: se replica el
 * comportamiento respetando el CSS de marca.
 */

// 21 zonas · viewBox 0 0 120 260 · [tipo, coords, nombre frente, nombre espalda].
const ZONAS = [
  ['circle', '60,22,17', 'Cabeza', 'Nuca'],
  ['rect', '51,40,18,12,4', 'Cuello', 'Cervicales'],
  ['rect', '28,53,22,16,7', 'Hombro derecho', 'Trapecio derecho'],
  ['rect', '70,53,22,16,7', 'Hombro izquierdo', 'Trapecio izquierdo'],
  ['rect', '42,53,36,30,8', 'Pecho', 'Espalda alta'],
  ['rect', '42,85,36,30,8', 'Abdomen', 'Zona lumbar'],
  ['rect', '24,71,18,34,8', 'Brazo derecho', 'Brazo derecho'],
  ['rect', '78,71,18,34,8', 'Brazo izquierdo', 'Brazo izquierdo'],
  ['rect', '21,107,17,32,8', 'Antebrazo derecho', 'Codo derecho'],
  ['rect', '82,107,17,32,8', 'Antebrazo izquierdo', 'Codo izquierdo'],
  ['rect', '19,141,17,16,7', 'Mano derecha', 'Mano derecha'],
  ['rect', '84,141,17,16,7', 'Mano izquierda', 'Mano izquierda'],
  ['rect', '40,117,40,20,8', 'Cadera', 'Glúteos'],
  ['rect', '40,139,18,42,8', 'Muslo derecho', 'Isquiotibial derecho'],
  ['rect', '62,139,18,42,8', 'Muslo izquierdo', 'Isquiotibial izquierdo'],
  ['rect', '40,183,18,16,7', 'Rodilla derecha', 'Detrás de la rodilla dcha.'],
  ['rect', '62,183,18,16,7', 'Rodilla izquierda', 'Detrás de la rodilla izda.'],
  ['rect', '41,201,16,36,7', 'Pierna derecha', 'Gemelo derecho'],
  ['rect', '63,201,16,36,7', 'Pierna izquierda', 'Gemelo izquierdo'],
  ['rect', '39,239,18,14,6', 'Pie derecho', 'Talón derecho'],
  ['rect', '63,239,18,14,6', 'Pie izquierdo', 'Talón izquierdo'],
];
/* AQUÍ ESTABA «¿Qué ha pasado?» con sus cinco respuestas · RETIRADO.
   Ann, 28-ago-2026: «toda la ristra de respuestas fuera; ya el dolor es
   suficiente información y la intensidad queda registrada en los clics».
   Y al quitarlo pasa algo bueno: la rejilla daba 300 px al dibujo y el resto
   al menú — por eso los muñecos salían diminutos. Sin menú, se quedan con
   toda la pantalla. Menos que decidir y además se ve mejor. */
/* EL CLIC ES EL NIVEL (Ann, 28-ago-2026). Antes había que marcar la zona Y
   ADEMÁS mover una barra de 0 a 10: dos veces el mismo dato y dos formas de
   equivocarse. Ahora el número sale del propio toque y se ve JUNTO A LA MARCA:

       1 toque → 1     2 toques → 3     3 toques → 5     4 → se borra

   Fuera las etiquetas de al lado y fuera la barra final: el nivel concreto ya
   está marcado en los clics. Menos que leer, menos que decidir. */
const CLIC_A_DOLOR = { 1: 1, 2: 3, 3: 5 };

/* DE LO GUARDADO AL DIBUJO · para poder LEER lo que marcó la paciente.
   Hasta ahora este componente solo sabía preguntar: se guardaba lo que ella
   marcaba y nadie podía volver a verlo. Se le pedía un dato para nada.
   Lo guardado es {zona: 'Hombro derecho', intensidad: 1|2|3}. Aquí se busca
   ese nombre en la tabla de ZONAS -- primero por delante, luego por detrás --
   y se reconstruye la clave 'cara:idx' que usa el dibujo.
   Una zona que no se reconoce se OMITE: mejor que falte a que se pinte en el
   sitio equivocado, que en un mapa de dolor sería decir una mentira. */
const marcasAIntens = (marcas) => {
  const out = {};
  (marcas || []).forEach((m) => {
    const nombre = String(m.zona || '');
    let idx = ZONAS.findIndex((z) => z[2] === nombre);
    let cara = 'frente';
    if (idx < 0) { idx = ZONAS.findIndex((z) => z[3] === nombre); cara = 'espalda'; }
    if (idx < 0) return;
    const n = Number(m.intensidad);
    if (!Number.isFinite(n) || n < 1) return;
    out[`${cara}:${idx}`] = Math.min(3, Math.round(n));
  });
  return out;
};

const MapaDolor = ({ onRegistrar, onCancelar, marcas = null, soloLectura = false }) => {
  // la clave lleva la cara: 'frente:3' / 'espalda:3'. Una misma zona puede
  // doler por delante y no por detrás, y son dos marcas distintas.
  // Con `marcas` entra en MODO LECTURA: pinta lo que ella marcó aquel día.
  const [intens, setIntens] = useState(() => (marcas ? marcasAIntens(marcas) : {}));
  const [aviso, setAviso] = useState('');

  const hayZona = Object.values(intens).some((n) => n > 0);

  const tocar = (cara, idx) => {
    // en modo lectura el dibujo NO se toca: es el registro de un día pasado,
    // no un formulario. Si se pudiera tocar, el fisio reescribiría sin querer
    // lo que dijo la paciente.
    if (soloLectura) return;
    const k = `${cara}:${idx}`;
    setIntens((m) => {
      const n = ((m[k] || 0) + 1) % 4;
      const nx = { ...m };
      if (n === 0) delete nx[k]; else nx[k] = n;
      return nx;
    });
  };

  const registrar = () => {
    if (!hayZona) { setAviso('Marca en el dibujo dónde te duele antes de enviar.'); return; }
    const zonas = Object.keys(intens).map((k) => ({
      zona: ZONAS[k.split(':')[1]][k.startsWith('frente') ? 2 : 3],
      intensidad: intens[k],
      dolor: CLIC_A_DOLOR[intens[k]] || null,      // lo que dijo con los clics
    }));
    // El dolor del momento es EL PEOR de lo que ha marcado: si una zona le
    // duele 5 y otra 1, decir «1» sería quitarle importancia a lo que duele.
    const peor = Object.values(intens).reduce((a, n) => Math.max(a, CLIC_A_DOLOR[n] || 0), 0);
    onRegistrar({ motivo: '', zonas, eva: peor || null });
  };

  const nombre = (z, cara) => (cara === 'frente' ? z[2] : z[3]);
  const renderZona = (cara) => (z, idx) => {
    const n = intens[`${cara}:${idx}`] || 0;
    const cls = 'crm-portal-body__zone' + (n ? ' is-sel n' + n : '');
    if (z[0] === 'circle') {
      const [cx, cy, r] = z[1].split(',').map(Number);
      return <circle key={cara + idx} className={cls} cx={cx} cy={cy} r={r}
        onClick={() => tocar(cara, idx)}><title>{nombre(z, cara)}</title></circle>;
    }
    const [x, y, w, h, rx] = z[1].split(',').map(Number);
    return <rect key={cara + idx} className={cls} x={x} y={y} width={w} height={h} rx={rx}
      onClick={() => tocar(cara, idx)}><title>{nombre(z, cara)}</title></rect>;
  };

  /* LOS NÚMEROS, EN SU PROPIA CAPA Y ENCIMA DE TODO (Ann, 28-ago-2026: «hay
     una zona donde no aparece el número»).
     Antes cada número se dibujaba junto a SU zona, y en un SVG lo que se
     pinta después tapa lo de antes: el número del abdomen caía justo debajo
     del brazo, que se dibuja más tarde, y desaparecía. Pintándolos todos al
     final ya no puede taparlos nada. */
  const renderCifras = (cara) => ZONAS.map((z, idx) => {
    const n = intens[`${cara}:${idx}`] || 0;
    if (!n) return null;
    /* CENTRADO SOBRE LA PROPIA MARCA, no al lado. Al lado había dos
       problemas: el número de una zona central (el abdomen) caía encima del
       brazo, y dos zonas a la misma altura se pisaban entre ellas. Encima de
       su mancha no puede pasar ninguna de las dos cosas, y además se lee sin
       preguntarse de cuál es. */
    let cx; let cy;
    if (z[0] === 'circle') {
      const [ccx, ccy] = z[1].split(',').map(Number);
      cx = ccx; cy = ccy + 4;
    } else {
      const [x, y, w, h] = z[1].split(',').map(Number);
      cx = x + w / 2; cy = y + h / 2 + 4;
    }
    return <text key={cara + idx + '-n'} className={'crm-portal-body__cifra n' + n}
      x={cx} y={cy}>{CLIC_A_DOLOR[n]}</text>;
  });

  return (
    <div className="parada on">
      <div className="parada-grid">
        {/* Izquierda · el muñeco */}
        <div>
          <div className="fv-dolor-orden">Marca las zonas de dolor</div>
          <div className="fv-dolor-orden__sub">Y dale <b>dos o tres veces</b> para decir cuánto te duele.</div>
          <div className="fv-dolor-clave">
            <span className="fv-dolor-clave__it"><i className="n1" />Un toque · molesta</span>
            <span className="fv-dolor-clave__it"><i className="n2" />Dos · duele</span>
            <span className="fv-dolor-clave__it"><i className="n3" />Tres · duele mucho</span>
          </div>
          <div className="crm-portal-body">
            {/* LOS DOS MUÑECOS, A LA VEZ (Ann, 28-ago-2026): «como la gente es
                mayor casi prefiero dos muñecos, uno de frente y otro de
                espaldas». Antes había UNO y un botón para cambiar de cara — y
                con gente mayor eso es una trampa: si no ve el botón, la
                espalda no existe para ella, y el dolor de espalda es el más
                común de todos. Ahora no hay nada que descubrir. */}
            <div className="fv-dosmunecos">
              <div className="fv-muneco">
                <svg className="crm-portal-body__svg" viewBox="0 0 120 260">
                  {ZONAS.map(renderZona('frente'))}
                  {renderCifras('frente')}
                  {/* LA CARA · solo en el de frente, y es lo que dice de un
                      vistazo cuál es cuál. Sin rótulos que leer. */}
                  <g className="fv-muneco__cara">
                    <circle cx="54" cy="19" r="1.6" />
                    <circle cx="66" cy="19" r="1.6" />
                    <path d="M60 22v4" />
                  </g>
                </svg>
                <span className="fv-muneco__rot">De frente</span>
              </div>
              <div className="fv-muneco">
                <svg className="crm-portal-body__svg" viewBox="0 0 120 260">
                  {ZONAS.map(renderZona('espalda'))}
                  {renderCifras('espalda')}
                </svg>
                <span className="fv-muneco__rot">De espaldas</span>
              </div>
            </div>
          </div>
          <p className="fv-dolor-pista">{soloLectura
            ? (hayZona ? 'Esto es lo que marcó la paciente ese día.' : 'Ese día no marcó ninguna zona.')
            : (hayZona ? 'Vuelve a tocar la misma zona si te duele más: el número sube. Al cuarto toque se borra.' : 'Toca la zona donde te duele. Puedes marcar más de una.')}</p>
        </div>

        {/* En modo LECTURA no hay pie: no hay nada que registrar ni que
            cancelar. Un botón que no hace falta es un botón que confunde. */}
        {!soloLectura && (
          <div>
            {aviso && <div className="aviso-zona on">{aviso}</div>}
            <div className="parada__pie">
              <button type="button" className="fv-btn fv-btn--secundario" onClick={onCancelar}>Cancelar</button>
              <button type="button" className="fv-btn fv-btn--violeta" onClick={registrar}>Registrar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapaDolor;
